var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_color_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_color_svg__ds",
    x1: 248.32,
    y1: 298.38,
    x2: 346.94,
    y2: 298.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m260.32,249.06c-3.21,0-6.22,1.25-8.48,3.51-2.27,2.27-3.52,5.28-3.52,8.49s1.25,6.22,3.52,8.48l74.62,74.62c2.27,2.27,5.28,3.52,8.49,3.52s6.22-1.25,8.48-3.51c2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.52-8.48l-74.62-74.62c-2.27-2.27-5.28-3.52-8.49-3.52Z",
    fill: "url(#search_color_svg__ds)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m297.41,189.49c0-59.1-48.08-107.17-107.17-107.17s-107.17,48.08-107.17,107.17,48.08,107.17,107.17,107.17,107.17-48.08,107.17-107.17Zm-191,0c0-46.22,37.6-83.83,83.83-83.83s83.83,37.6,83.83,83.83-37.6,83.83-83.83,83.83-83.83-37.6-83.83-83.83Z",
    fill: "#f7f7f7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchColor);
export default __webpack_public_path__ + "static/media/search_color.e826aefd7026c639d8c13200e7b731fe.svg";
export { ForwardRef as ReactComponent };